var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"redes-view"},[_c('RedesNavbar'),_c('BannerRedes'),_c('CategoriasRedes'),_c('RedesFqa'),_c('FooterSection')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }